import { Affix } from "antd";
import { useOutlet } from "react-router-dom";
import { isInIframe } from "@/utils";
import { Header } from "./head";
import { Footer } from "./footer";
import styles from "./style.module.scss";

export const SingleTitleLayout = () => {
  const outlet = useOutlet();
  return (
    <div className={styles.globalWrapper}>
      <Affix>
        <div>{!isInIframe() && <Header noTabs />}</div>
        <div
          style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className={styles.singleTitleWrapper}>
            <img
              className={styles.singleTitleLogo}
              src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/logo.png"
              alt="logo"
              style={{ width: 101, height: 60 }}
            />
            <span>高级企采商会员+优质采平台会员</span>
          </div>
        </div>
      </Affix>
      <div className={styles.outLayoutWrapper}>
        <div className={styles.layoutWrapper} style={{ width: "100%" }}>
          <div className={styles.layoutContent}>{outlet}</div>
        </div>
      </div>
      <div style={{ width: 1200, margin: "0 auto" }}>
        {!isInIframe() && <Footer />}
      </div>
    </div>
  );
};
